module.exports = __webpack_public_path__ + "static/media/condor.d5b58a39.svg";